import { render, staticRenderFns } from "./HomeScreen.vue?vue&type=template&id=b3c5b7f2&"
import script from "./HomeScreen.vue?vue&type=script&lang=ts&"
export * from "./HomeScreen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports